import { useDragHandlers } from './useDragHandlers.js';
import { useDragSensors } from './useDragSensors.js';
import { useDragState } from './useDragState.js';

const useDrag = ({
  useGeneric,
  activationConstraint,
  defaultTranslate,
  idArray,
  removable,
  reorderIds,
  setIdArray,
  coordinateGetter
}) => {
  const sensors = useDragSensors({
    useGeneric: useGeneric,
    activationConstraint,
    coordinateGetter
  });
  const {
    activeId,
    setActiveId,
    transformState,
    setTransformState
  } = useDragState({
    defaultTranslate
  });
  const getIndex = id => idArray.indexOf(id);
  const handleRemove = removable ? id => setIdArray(ids => ids.filter(item => item !== id)) : undefined;
  const dragHandlers = useDragHandlers({
    useGeneric: useGeneric,
    activeId,
    setActiveId,
    setTransformState,
    getIndex,
    setIdArray,
    reorderIds
  });
  return {
    sensors,
    activeId,
    activeIndex: activeId ? getIndex(activeId) : -1,
    ...transformState,
    handleRemove,
    ...dragHandlers
  };
};

export { useDrag };
